import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "focus-push-settings" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "warning"
}
const _hoisted_5 = {
  key: 1,
  class: "warning"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 1 }

import StudioSelectField from "../../../StudioSelectField.vue";
import { computed } from "vue";
import type { DialogueNode, FocusPushClip } from "../../types/DialogueNode";
import { resolveGroupOutlets } from "../../utils/groupOutlets";


export default /*@__PURE__*/_defineComponent({
  __name: 'FocusPushClipEditor',
  props: {
    node: {},
    clip: {}
  },
  setup(__props: any) {

const props = __props;
const sharedOutlets = computed(() =>
  resolveGroupOutlets(props.node).outlets
    .filter((outlet) => outlet.kind !== "FocusPush")
    .map((outlet, index) => ({
      index,
      label: outlet.kind === "Select"
        ? outlet.label + "：" + (props.node.select?.options.find(option => option.id === outlet.optionId)?.content || "未填写选项")
        : outlet.label,
    })),
);
const hasSelectedOutlet = computed(() =>
  sharedOutlets.value.some(outlet => outlet.index === props.clip.sharedOutletIndex),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _cache[3] || (_cache[3] = _createTextVNode(" 输出方式 ", -1)),
      _createVNode(StudioSelectField, {
        modelValue: __props.clip.outputMode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.clip.outputMode) = $event)),
        "aria-label": "Focus Push 输出方式"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("option", { value: "Self" }, "独立出口", -1),
          _createElementVNode("option", { value: "Shared" }, "共用出口", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (__props.clip.outputMode === 'Shared')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("label", null, [
            _cache[4] || (_cache[4] = _createTextVNode(" 共用的出口 ", -1)),
            _createVNode(StudioSelectField, {
              modelValue: __props.clip.sharedOutletIndex,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.clip.sharedOutletIndex) = $event)),
              disabled: !sharedOutlets.value.length,
              "aria-label": "Focus Push 共用出口"
            }, {
              default: _withCtx(() => [
                (!hasSelectedOutlet.value)
                  ? (_openBlock(), _createElementBlock("option", {
                      key: 0,
                      value: __props.clip.sharedOutletIndex,
                      disabled: ""
                    }, "请选择有效出口", 8, _hoisted_2))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sharedOutlets.value, (outlet) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: outlet.index,
                    value: outlet.index
                  }, _toDisplayString(outlet.index) + " · " + _toDisplayString(outlet.label), 9, _hoisted_3))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          (!sharedOutlets.value.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "暂无可共用的出口，请启用玩家按下推进，或添加 Select 选项。"))
            : (!hasSelectedOutlet.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "原出口序号已不可用，请重新选择。"))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, "时间到达后使用所选出口，不新增 Focus Push 出口。"))
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_7, "在节点图连接独立的 Focus Push 出口，指定下一句话。")),
    _cache[5] || (_cache[5] = _createElementVNode("p", null, "拖动 Clip 设置触发时间。", -1))
  ]))
}
}

})